<template>
  <div class="view container">
    <el-row :gutter="20" type="flex">
      <el-col :xs="24">
        <h1 class="font--bigger m-t-0 c-black">
          <span>{{ $t('connect.SocialMedia') }}</span>
        </h1>
      </el-col>
    </el-row>

    <el-card :body-style="{ padding: '0.625rem 1rem 1rem' }">
      <el-row>
        <el-col :xs="24">
          <!-- Tabs -->
          <el-tabs v-model="activeTab">
            <el-tab-pane label="Facebook" name="facebook" v-if="isFacebookVisible">
              <FormConnectSocialMedia :data="currentConfig" :platform="currentPlatform" @refresh="requerstSocialMediaConfigs" />
            </el-tab-pane>
            <el-tab-pane label="Instagram" name="instagram" v-if="isInstagramVisible">
              <FormConnectSocialMedia :data="currentConfig" :platform="currentPlatform" @refresh="requerstSocialMediaConfigs" />
            </el-tab-pane>
          </el-tabs>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
/* eslint-disable no-undef */
import { mapGetters } from 'vuex';
import { get } from 'lodash';
import { MODULE_NAME as TAGS_MODULE } from '@/store/modules/bb_tags';
import { MODULE_NAME as USER_MODULE } from '@/store/modules/user';
import FormConnectSocialMedia from '@/components/Form/Connect/FormConnectSocialMedia';
import * as SocialMediaConfigService from '@/services/bb_sm_config';
import * as SocialMediaPlatformsService from '@/services/socialmedia_platforms';

export default {
  name: 'IndexSocialMedia',

  components: {
    FormConnectSocialMedia
  },

  computed: {
    ...mapGetters({
      company: `${USER_MODULE}/company`
    }),

    companyId() {
      return get(this.company, 'id');
    },

    currentConfig() {
      let result = {};
      if (this.configs.length) {
        const config = this.configs.find(item => {
          return this.activeTab === get(item, 'platform.slug', '');
        });
        if (config) {
          result = Object.assign({}, config);
        }
      }
      return result;
    },

    currentPlatform() {
      return this.platforms.find(item => item.slug === this.activeTab);
    },

    isFacebookVisible() {
      return this.platforms.some(item => item.slug === 'facebook');
    },

    isInstagramVisible() {
      return this.platforms.some(item => item.slug === 'instagram');
    }
  },

  data() {
    return {
      activeTab: 'facebook',
      configs: [],
      isLoading: false,
      platforms: []
    };
  },

  mounted() {
    this.init();
    this.addFacebookSDK();
  },

  methods: {
    init() {
      this.requestPlatforms();
      this.$store.dispatch(`${TAGS_MODULE}/GET_TAGS`);
      if (this.companyId) {
        this.requerstSocialMediaConfigs(this.companyId);
      }
    },

    /**
     * Add facebook SDK to page
     * @ToDo  use env variables for appId
     *
     * @return  {void}
     */
    addFacebookSDK() {
      const apiVersion = 'v10.0';
      const appId = '549054656472368';

      window.fbAsyncInit = () => {
        FB.init({
          appId: appId,
          cookie: true,
          xfbml: true,
          version: apiVersion
        });
      };

      var js,
        fjs = document.getElementsByTagName('script')[0];
      if (document.getElementById('facebook-jssdk')) {
        return;
      }
      js = document.createElement('script');
      js.id = 'facebook-jssdk';
      js.src = 'https://connect.facebook.net/en_US/sdk.js';
      fjs.parentNode.insertBefore(js, fjs);
    },

    async requestPlatforms() {
      try {
        const response = await SocialMediaPlatformsService.getPlatforms();
        const data = get(response, 'data', []);
        console.log(data, response);
        if (data.length) {
          this.platforms = data.slice();
        }
      } catch (error) {
        throw new Error(error);
      }
    },

    async requerstSocialMediaConfigs(companyId) {
      try {
        this.isLoading = true;
        const response = await SocialMediaConfigService.getConfigsByCompany(companyId);
        const data = get(response, 'data', []);
        console.log(response, data);
        if (data.length) {
          this.configs = data.slice();
        }
      } catch (error) {
        throw new Error(error);
      } finally {
        this.isLoading = false;
      }
    }
  },

  watch: {
    companyId(newValue) {
      if (newValue) {
        this.requerstSocialMediaConfigs(this.companyId);
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
